import CountriesPage from "../../pages/legacy/countries/CountriesPage";

const route = {
  key: "countries",
  path: "/legacy/countries",
  component: CountriesPage,
  private: true,
  layout: "main",
  icon: "faGlobe",
  group: "masterdata",
  order: 20,
  permission: "legacy.countries.read"
};

export default route;